<template>
  <div :class="{ 'form-control': true, 'is-select': true }">
    <v-select
      :options="tags"
      v-model="tagValue"
      :placeholder="$t('selectTag.enterTag')"
      :taggable="true">
      <template slot="no-options">
        <template v-if="!emptyResults">{{ $t('ui.searching') }}&hellip;</template>
        <template v-if="emptyResults">{{ $t('selectTag.noTagsMatchingPhrase') }}&hellip;</template>
      </template>
    </v-select>
    <small v-if="loadError">
      {{ $t('selectTag.errorOccurred') }}
    </small>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'select-tag',
  data () {
    return {
      tagValue: '',
      loadedTags: false,
      tags: [],
      loadError: false,
      emptyResults: false
    }
  },
  watch: {
    loadedTags (newValue) {
      if (newValue) {
        this.$bus.$emit('market-customer-tags-loaded');
      }
    },
    loadError (newValue) {
      if (newValue) {
        this.$bus.$emit('market-customer-data-load-error');
      }
    }
  },
  mounted () {
    FormUtils.loadAdditionalData(this, {
      endpoint: '/market-customers/tags',
      loadedKey: 'loadedTags',
      outputKey: 'tags',
      errorKey: 'loadError'
    });
  }
}
</script>
